import React from "react";
import Cross from '../pics/svg/cross.svg'
import firebase from 'firebase/app';
import "./logout.css";

function Logout() {

    const auth = firebase.auth();

    function closeLogout() {
        document.querySelector('.logout-wrapper').style.transform = "scale(0.8)"
        document.querySelector('.logout-wrapper').style.opacity = 0
        document.querySelector('.logout-wrapper').style.pointerEvents = "none"
        document.querySelector('button.Logout').style.pointerEvents = "none"
    }

    function onLogoutClick() {
        auth.signOut();
        closeLogout();
    }


    return (
        <div className="logout-wrapper">
            <div className="logout-container">
                <img onClick={closeLogout} className="close" src={Cross} alt="X"/>
                <div className="logout-heading">Sure you wanna log out?</div>
                <button onClick={onLogoutClick} className="Logout">Log out</button>
            </div>
        </div>
    );
}

export default Logout;
